import { GetInstitutionsByUserResponse } from '@/api/dtos';
import IsLoading from '@/components/layouts/IsLoading';
import InstitutionsContext from '@/contexts/data/InstitutionsContext';
import useInstitutionsByUser from '@/hooks/data/useInstitutionsByUser';
import { FC, PropsWithChildren } from 'react';


export interface IInstitutionsProviderProps {
    initial?: GetInstitutionsByUserResponse;
}

export const InstitutionsProvider: FC<PropsWithChildren<IInstitutionsProviderProps>> = ({ initial, children }) => {
    const institutions = useInstitutionsByUser({ revalidateOnFocus: false, fallbackData: initial});

    return (
        <InstitutionsContext.Provider value={institutions}>
            <IsLoading name="institutions" loading={institutions.loading} validating={institutions.validating}/>
            {children}
        </InstitutionsContext.Provider>
    );
}

export default InstitutionsProvider;
